import { getMyContribute, getContributeSummary, getNativeActivityTabList } from "@/server/interfaces"
import { resolveWorkList } from "@/utils/resolveWorkList"

export default {
  namespaced: true,
  state: {
    myContributeList: [],
    contributeSummary: {
      likeNum: 0,
      activityNum: 0,
      worksNum: 0
    },
    noMoreContribute: false,
    scrollTop: 0,
    nativeActivityTabId: 0
  },
  mutations: {
    SAVE_MY_CONTRIBUTE_LIST(state, myContributeList) {
      state.myContributeList = myContributeList
    },
    SET_NO_MORE_CONTRIBUTE(state, status) {
      state.noMoreContribute = status
    },
    SAVE_SCROLL_TOP(state, scrollTop) {
      state.scrollTop = scrollTop
    },
    SET_CONTRIBUTE_SUMMARY(state, contributeSummary) {
      state.contributeSummary = Object.assign({}, state.contributeSummary, contributeSummary)
    },
    SET_NATIVE_ACTIVITY_TAB_ID(state, tabId) {
      state.nativeActivityTabId = tabId
    }
  },
  actions: {
    async getMyContribute({ commit, rootState }, params) {
      const _myContributeList = rootState.myContribute.myContributeList
      const {
        params: { page }
      } = params
      const { activityWorksSummaryVO: myContributeList, hasNextPage } = await getMyContribute(params)
      myContributeList.forEach(activityItem => {
        if (activityItem.works) {
          resolveWorkList(activityItem.works)
        }
      })
      if (page === 0) {
        commit("SAVE_MY_CONTRIBUTE_LIST", myContributeList)
      } else {
        commit("SAVE_MY_CONTRIBUTE_LIST", [..._myContributeList, ...myContributeList])
      }
      commit("SET_NO_MORE_CONTRIBUTE", !hasNextPage)
    },
    async getContributeSummary({ commit }, params) {
      const contributeSummary = await getContributeSummary(params)
      commit("SET_CONTRIBUTE_SUMMARY", contributeSummary)
    },
    async getNativeActivityTabId({ commit }) {
      const TAB_NAME = "征稿"
      const tabList = await getNativeActivityTabList()
      const contributeTabItem = tabList.find(item => item.columnName === TAB_NAME)
      if (contributeTabItem) {
        commit("SET_NATIVE_ACTIVITY_TAB_ID", contributeTabItem.id)
      }
    }
  }
}
